import { ProcessedSubHead } from "@app/types/Opensearch";
import ApplyParagraphAnnotations from "@elements/ArticleParagraph/ApplyParagraphAnnotations";
import Heading from "@elements/Typography/Heading";
import { twMerge } from "tailwind-merge";

type SubHeadProps = {
  element: ProcessedSubHead;
  className?: string;
};

export default function SubHead({ element, className }: SubHeadProps) {
  return (
    <Heading
      className={twMerge("font-medium text-xl text-black-300", className)}
      Element={element.headingTag}
    >
      {ApplyParagraphAnnotations(element.subhead, element.annotations)}
    </Heading>
  );
}
